import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'users';
let baseUrl = config.apiBaseUrl;

export default {
  getOwn() {
    return axios.get(baseUrl + '/' + restModel + '/getOwn', RequestConfig);
  },

  getAll(filters) {
    let filterString = '';
    if(filters && filters.where) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'where=' + JSON.stringify(filters.where);
    }
    if(filters && filters.limit) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'limit=' + filters.limit;
    }
    return axios.get(baseUrl + '/' + restModel + filterString, RequestConfig);
  },

  search(searchData){
    return axios.post(baseUrl + '/' + restModel + '/search', searchData, RequestConfig);
  },

  // getById(id) {
  //   return axios.get(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  // },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, RequestConfig);
  },

  validateField(fields) {
    return axios.post(baseUrl + '/' + restModel + '/validate-field', fields, RequestConfig);
  },

  update(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, RequestConfig);
  },

  // deleteById(id) {
  //   return axios.delete(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  // },

  sendActivationEmail(userId) {
    return axios.post(baseUrl + '/' + restModel + '/' + userId + '/sendActivationEmail', null, RequestConfig);
  },

  reinstate(userId){
    return axios.post(baseUrl + '/' + restModel + '/reinstate/' + userId, null, RequestConfig);
  },

  suspend(userId){
    return axios.post(baseUrl + '/' + restModel + '/suspend/' + userId, null, RequestConfig);
  },

  updateSlack(message){
    var content = {"text":message}
    axios.post('https://hooks.slack.com/services/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', JSON.stringify(content), {'Content-Type': 'application/json'});
  }
}
